import { datadogRum } from "@datadog/browser-rum";

const COLD_RESTART_KEYS = {
	SESSION_ALIVE: "sok_session_alive",
	LAST_VISIBILITY_TS: "sok_last_visibility_ts",
} as const;

// Detect when the TWA Chrome process was OOM-killed during idle and emit a
// Datadog RUM action so we can quantify cold-restart frequency on Sunmi POS.
// sessionStorage is per-browsing-context: Chromium clears it on process kill,
// but localStorage survives. "No session-alive flag + non-zero last-visibility
// ts" identifies a cold-start that followed a previous run, distinct from a
// genuine first-time load.
export const trackAppLifecycleForColdRestart = (): void => {
	const lastVisibilityTs = Number(
		localStorage.getItem(COLD_RESTART_KEYS.LAST_VISIBILITY_TS) ?? "0"
	);
	const wasAlive = sessionStorage.getItem(COLD_RESTART_KEYS.SESSION_ALIVE) === "1";

	if (!wasAlive && lastVisibilityTs > 0) {
		datadogRum.addAction("app.cold_restart", {
			time_since_last_visibility_ms: Date.now() - lastVisibilityTs,
		});
	}

	sessionStorage.setItem(COLD_RESTART_KEYS.SESSION_ALIVE, "1");

	const persistVisibilityTs = () => {
		localStorage.setItem(COLD_RESTART_KEYS.LAST_VISIBILITY_TS, Date.now().toString());
	};

	window.addEventListener("pagehide", persistVisibilityTs);
	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "hidden") persistVisibilityTs();
	});
};
